module.exports = new __parcel__URL__("bitpie.f7f37a63.svg").toString();